export const MAX_SEARCH_WORDS = 10;
export const MAX_SEARCH_CHARACTERS = 200;
export const PAGE_SIZE = 48;
export const MEAL_DEAL_SIZE = 100;
